import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_SPECIALIST_STATUS_PROVIDER =
  'UPDATE_SPECIALIST_STATUS_PROVIDER';
export const UPDATE_SPECIALIST_STATUS_PROVIDER_SUCCESS =
  'UPDATE_SPECIALIST_STATUS_PROVIDER_SUCCESS';
export const UPDATE_SPECIALIST_STATUS_PROVIDER_FAILURE =
  'UPDATE_SPECIALIST_STATUS_PROVIDER_FAILURE';

// Action Creators
export const fetchUpdateSpecialistStatusProvider = () => ({
  type: UPDATE_SPECIALIST_STATUS_PROVIDER,
});

export const fetchUpdateSpecialistStatusProviderSuccess = (data) => ({
  type: UPDATE_SPECIALIST_STATUS_PROVIDER_SUCCESS,
  payload: data,
});

export const fetchUpdateSpecialistStatusProviderFailure = (error) => ({
  type: UPDATE_SPECIALIST_STATUS_PROVIDER_FAILURE,
  payload: error,
});

// Thunk Function
export const updateSpecialistStatusProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateSpecialistStatusProvider(data, external));
    try {
      const response = await putMethodWithToken(
        url.updateSpecialistStatusProvider + external?.id + '/update/status/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateSpecialistStatusProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateSpecialistStatusProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateSpecialistStatusProviderFailure(error.message));
    }
  };
};
